import {useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {Button} from "../account/misc/Button";
import PosApi from "../../api/PosApi";
import {useRecoilValue} from "recoil";
import {memberState} from "../../state/atoms";
import {isTestEnv} from "../../util/constants";
import {Spinner} from "../account/misc/Spinner";
import CheckCircle from "../icons/CheckCircle";
import './Popmenu.scss';
import {handleServerError} from "../../util/ErrorHandler";

export default function Popmenu() {
  const [searchParams] = useSearchParams();
  const member = useRecoilValue(memberState);
  const [linked, setLinked] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!member || !member.id) return;

    const code = searchParams.get("code");
    const error = searchParams.get("error");

    if (!code && !error) return;

    if (error === 'access_denied') {
      alert('Access was not permitted :(');
    } else if (code) {
      setLoading(true);
      PosApi.authPopmenu({code, memberId: member.internalId}).then(() => {
        setLoading(false);
        setLinked(true);
        const url = window.location.href.split('?')[0];
        window.history.pushState({path: url}, "", url);
      }).catch(e => {
        setLoading(false);
        handleServerError(e);
      });
    } else {
      alert('No code :(');
    }
  }, [searchParams, member]);

  function connect() {
    const clientId = isTestEnv ? 'sWCG2L1f3-Fxtj5wNB1RnzqiVmfJxIuNbCIwRYPlmEY' : '';
    const redirectUri = isTestEnv ? 'https://test.mhmfun.com/home-test/popmenu' : '';
    const scopes = isTestEnv ? 'menus_read' : '';
    window.location.href = `https://my.popmenu.com/oauth/authorize?client_id=${clientId}&response_type=code&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${scopes}`;
  }

  return <>
    {loading && <div className={'spinner'}><Spinner/></div>}
    {!linked && !loading && <Button onClick={connect}>Login into Popmenu</Button>}
    {linked && <div className={'popmenu-linked'}>
      <CheckCircle/>
      <h2>You're all set!</h2>
      <p>You can access your Popmenu data in any design.</p>
    </div>}
  </>
}
